/*
Seth Rollins	8/29/2012	NXT
Big E Langston	1/9/2013	NXT
Bo Dallas	6/12/2013	NXT
Adrian Neville	2/27/2014	NXT Arrival
Sami Zayn	12/11/2014	NXT TakeOver: Rival
Kevin Owens	2/11/2015	NXT TakeOver: R Evolution
Finn Bálor	7/4/2015	The Beast in the East
Samoa Joe	4/21/2016	NXT Live Event
Shinsuke Nakamura	8/20/2016	NXT TakeOver: Brooklyn II
Samoa Joe	11/19/2016	NXT TakeOver: Toronto
Shinsuke Nakamura	12/3/2016	NXT
Bobby Roode	1/28/2017	NXT TakeOver: San Antonio
Drew McIntyre	8/19/2017	NXT TakeOver: Brooklyn III
Andrade "Cien" Almas	11/18/2017	NXT TakeOver: WarGames
Aleister Black	4/7/2018	NXT TakeOver: New Orleans
Tommaso Ciampa	7/25/2018	NXT
Vacant	3/20/2019	NXT
Johnny Gargano	4/5/2019	NXT TakeOver: New York
Adam Cole	6/1/2019	NXT TakeOver: XXV
Keith Lee	7/8/2020	NXT: The Great American Bash
Karrion Kross	8/22/2020	NXT TakeOver: XXX
Vacant	3/24/2020	NXT
Finn Bálor	9/1/2020	NXT: Super Tuesday II
Karrion Kross	4/8/2021	NXT TakeOver: Stand & Deliver
Samoa Joe	8/22/2021	NXT TakeOver 36
Vacant	9/12/2021	—
Tommaso Ciampa	9/14/2021	NXT 2.0
Bron Breakker	1/4/2022	NXT 2.0: New Year's Evil
Dolph Ziggler	3/8/2022	NXT 2.0: Roadblock
Bron Breakker	4/4/2022	Raw
Carmelo Hayes	4/1/2023	NXT Stand & Deliver
Ilja Dragunov	9/30/2023	NXT No Mercy
*/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _default = [
    {
        id: "nxt-mens-01",
        wrestlerIds: [
            "ilja-dragunov"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Sep 30, 2023")
    },
    {
        id: "nxt-mens-02",
        wrestlerIds: [
            "carmelo-hayes"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Apr 1, 2023"),
        endDate: new Date("Sep 30, 2023")
    },
    {
        id: "nxt-mens-03",
        wrestlerIds: [
            "bron-breakker"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Apr 4, 2022"),
        endDate: new Date("Apr 1, 2023")
    },
    {
        id: "nxt-mens-04",
        wrestlerIds: [
            "dolph-ziggler"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Mar 8, 2022"),
        endDate: new Date("Apr 4, 2022")
    },
    {
        id: "nxt-mens-05",
        wrestlerIds: [
            "bron-breakker"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Jan 4, 2022"),
        endDate: new Date("Mar 8, 2022")
    },
    {
        id: "nxt-mens-06",
        wrestlerIds: [
            "tommaso-ciampa"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Sep 14, 2021"),
        endDate: new Date("Jan 4, 2022")
    },
    {
        id: "nxt-mens-07",
        wrestlerIds: [
            "samoa-joe"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Aug 22, 2021"),
        endDate: new Date("Sep 14, 2021")
    },
    {
        id: "nxt-mens-08",
        wrestlerIds: [
            "karrion-kross"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Apr 8, 2021"),
        endDate: new Date("Aug 22, 2021")
    },
    {
        id: "nxt-mens-09",
        wrestlerIds: [
            "finn-balor"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Sep 1, 2020"),
        endDate: new Date("Apr 8, 2021")
    },
    {
        id: "nxt-mens-10",
        wrestlerIds: [
            "karrion-kross"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Aug 22, 2020"),
        endDate: new Date("Sep 1, 2020")
    },
    {
        id: "nxt-mens-11",
        wrestlerIds: [
            "keith-lee"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Jul 8, 2020"),
        endDate: new Date("Aug 22, 2020")
    },
    {
        id: "nxt-mens-12",
        wrestlerIds: [
            "adam-cole"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Jun 1, 2019"),
        endDate: new Date("Jul 8, 2020")
    },
    {
        id: "nxt-mens-13",
        wrestlerIds: [
            "johnny-gargano"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Apr 5, 2019"),
        endDate: new Date("Jun 1, 2019")
    },
    {
        id: "nxt-mens-14",
        // Tommaso Ciampa	7/25/2018
        wrestlerIds: [
            "tommaso-ciampa"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Jul 25, 2018"),
        endDate: new Date("Apr 5, 2019")
    },
    {
        id: "nxt-mens-15",
        wrestlerIds: [
            "aleister-black"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Apr 7, 2018"),
        endDate: new Date("Jul 25, 2018")
    },
    {
        id: "nxt-mens-16",
        wrestlerIds: [
            "andrade-cien-almas"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Nov 18, 2017"),
        endDate: new Date("Apr 7, 2018")
    },
    {
        id: "nxt-mens-17",
        wrestlerIds: [
            "drew-mcintyre"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Aug 19, 2017"),
        endDate: new Date("Nov 18, 2017")
    },
    {
        id: "nxt-mens-18",
        wrestlerIds: [
            "bobby-roode"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Jan 28, 2017"),
        endDate: new Date("Aug 19, 2017")
    },
    {
        id: "nxt-mens-19",
        wrestlerIds: [
            "shinsuke-nakamura"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Dec 3, 2016"),
        endDate: new Date("Jan 28, 2017")
    },
    {
        id: "nxt-mens-20",
        wrestlerIds: [
            "samoa-joe"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Nov 19, 2016"),
        endDate: new Date("Dec 3, 2016")
    },
    {
        id: "nxt-mens-21",
        wrestlerIds: [
            "shinsuke-nakamura"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Aug 20, 2016"),
        endDate: new Date("Nov 19, 2016")
    },
    {
        id: "nxt-mens-22",
        wrestlerIds: [
            "samoa-joe"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Apr 21, 2016"),
        endDate: new Date("Aug 20, 2016")
    },
    {
        id: "nxt-mens-23",
        wrestlerIds: [
            "finn-balor"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Jul 4, 2015"),
        endDate: new Date("Apr 21, 2016")
    },
    {
        id: "nxt-mens-24",
        wrestlerIds: [
            "kevin-owens"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Feb 11, 2015"),
        endDate: new Date("Jul 4, 2015")
    },
    {
        id: "nxt-mens-25",
        wrestlerIds: [
            "sami-zayn"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Dec 11, 2014"),
        endDate: new Date("Feb 11, 2015")
    },
    {
        id: "nxt-mens-26",
        wrestlerIds: [
            "adrian-neville"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Feb 27, 2014"),
        endDate: new Date("Dec 11, 2014")
    },
    {
        id: "nxt-mens-27",
        wrestlerIds: [
            "bo-dallas"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Jun 12, 2013"),
        endDate: new Date("Feb 27, 2014")
    },
    {
        id: "nxt-mens-28",
        wrestlerIds: [
            "big-e"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Jan 9, 2013"),
        endDate: new Date("Jun 12, 2013")
    },
    {
        id: "nxt-mens-29",
        wrestlerIds: [
            "seth-rollins"
        ],
        championshipId: "nxt-mens",
        startDate: new Date("Aug 29, 2012"),
        endDate: new Date("Jan 9, 2013")
    }
];
